import React from "react";
import { IoIosArrowDropright, IoMdCloseCircleOutline } from "react-icons/io";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { CiClock2 } from "react-icons/ci";
const Assesment = ({
  steps = [
    { label: "Applied", completed: true },
    { label: "MCQ's", completed: true },
    { label: "Technical\nInterview", completed: true },
    { label: "HR Interview", completed: false },
  ],
  percentage = 0,
  buttonName = "Complete Assesment",
  buttonAction = () => {
    alert("Complete Profile button clicked!");
  },
  description = "Complete your company profile to unlock full functionality and enhance your hiring potential.",
  closeIcon = (
    <IoMdCloseCircleOutline className="text-white text-xl rounded-full cursor-pointer bg-primary" />
  ),
  onClose, // Optional close action passed as prop
}) => {
  return (
    <div className="bg-[#151515] pt-2 whitespace-nowrap pl-0 w-[90%] md:h-[20%] md:w-[97%] md:p-10 rounded-xl flex md:flex-row lg:flex-row flex-col justify-around items-center relative px-10 m-5">
      {/* <div className=" text-primary rounded-full ">
        <IoMdCloseCircleOutline />
      </div> */}
      {/* Close Icon positioned at the top right */}
      <div
        className="absolute rounded-full w-6 h-6 flex items-center justify-center top-1 right-1 text-primary cursor-pointer "
        onClick={onClose} // Trigger the provided onClose function when clicked
      >
        <IoMdCloseCircleOutline />
      </div>

      {/* Circular Progress Bar */}
      <div className="text-white md:text-lg lg:text-lg text-sm  grow-1 -ml-[18%] text-center w-full mt-6 md:mt-0 md:ml-0 lg:ml-0 mr-auto ">
        <h1>Complete your Assesment.</h1>
      </div>

      {/* Progress Details */}
      <div className="lg:flex-row md:flex-row flex-col flex  ml-8 mt-6 md:mt-0 ">
        {/* Button Wrapper */}

        {/* Progress Steps */}
        <div className="flex flex-row md:flex-row grow items-center w-[80vw] md:w-[45vw] md:mb-[4%] md:ml-12 ml-2 ">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              {/* Step Circle */}
              <div
                className={`relative md:w-8 md:h-8 lg:w-8 lg:h-8 w-6 h-6 rounded-full ${
                  step.completed ? "bg-green-500" : "bg-white"
                } flex items-center justify-center`}
              >
                <span
                  className={`text-xs ${
                    step.completed ? "text-white" : "text-gray-400"
                  }`}
                >
                  <AiOutlineCheck />
                </span>

                {/* Label and Subtext */}
                <div className="absolute text-sm -bottom-10 flex flex-col justify-center items-center left-1/2 mt-20  mb-1 transform -translate-x-1/2 md:left-0 md:translate-x-0 text-white">
                  <span className="text-xs sm:text-sm md:text-base w-24 text-center md:text-left md:whitespace-nowrap whitespace-pre-line">
                    {step.label}
                  </span>
                </div>
              </div>

              {/* Connecting Line */}
              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-0.5 ${
                    steps[index].completed && steps[index + 1].completed
                      ? "bg-green-500"
                      : "bg-gray-400"
                  }`}
                ></div>
              )}
            </React.Fragment>
          ))}
        </div>
        <div className="md:flex-col lg:flex-col flex gap-2 flex-row btn bottom-0 mt-14 lg:mt-0 md:mt-0 mb-2 md:bottom-14 mx-auto md:ml-16 lg:ml-16 ml-0  px-4 py-2 my-55">
          <div className="md:hidden lg:hidden flex items-center justify-center mt-2 gap-2">
            <CiClock2 className="text-primary w-5 h-5" />
            <p className="text-primary">34 : 45 : 35</p>
          </div>
          <button
            className="flex justify-between p-2 items-center  my-55  text-sm md:text-md bg-primary mr-2 text-white rounded-full mt-8"
            onClick={buttonAction}
          >
            {buttonName}
            <IoIosArrowDropright className="ml-2 text-2xl text-white" />
          </button>
          <div className="hidden md:flex lg:flex items-center justify-center gap-2">
            <CiClock2 className="text-primary w-5 h-5" />
            <p className="text-primary">34 : 45 : 35</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assesment;
